import { render, staticRenderFns } from "./DemandCreate.vue?vue&type=template&id=bd88c788&scoped=true"
import script from "./DemandCreate.vue?vue&type=script&lang=js"
export * from "./DemandCreate.vue?vue&type=script&lang=js"
import style0 from "./DemandCreate.vue?vue&type=style&index=0&id=bd88c788&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88c788",
  null
  
)

export default component.exports